module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-chevron-up-icon-light-gray.24ee34ba.svg";